import { DialogProps, DisputeDialog, DisputeEventData, DisputeEventResult } from 'components';
import { DisputeEventTypes } from 'enums';
import { useDisputeService } from 'services';

/**
 * ReopenDispute component allows the user to reopen a closed dispute.
 * 
 * @param props - Additional properties passed to the Dialog
 * @returns Rendered component
 */
const ReopenDispute = (props: DialogProps) => {
    const disputeService = useDisputeService();
    const onSubmit = async (data: DisputeEventData) => {
        const result = await disputeService?.reopenDispute(data.disputeNumber, { ...data, eventTypeId: DisputeEventTypes.Reopened });
        return {
            error: !result && 'Error reopening dispute'
        } as DisputeEventResult;
    };

    return (
        <DisputeDialog
            initialValues={{ isPublic: false }}
            title="Reopen Dispute"
            submitLabel="Reopen"
            submittingLabel="Reopening"
            submitThemeColor="warning"
            onSubmit={onSubmit}
            {...props}
        />
    );
};

export default ReopenDispute;